// Central content source of truth for Equipping New Life
// <-- REPLACE placeholder photos/numbers with real NGO data when available -->

export const ORG = {
  name: "Equipping New Life",
  tagline: "Everyone Deserves a New Life",
  since: 2005,
  phone: "+919612489727",
  email: "equipenewlife2005@gmail.com",
  address: "Ithing Awang Leikai, Thanga Part-II, Bishnupur District, Manipur, India",
  areaOfOperation: "Bishnupur District, Manipur",
  regAct: "Manipur Societies Registration Act, 1989 (Manipur Act 1 of 1990)",
  regNo: "Reg. No. 110 of 2005",
  regDate: "30th March 2005",
  regAuthority: "Deputy Registrar of Societies, Bishnupur District",
  certification:
    "Certified by the Office of the Deputy Commissioner, Bishnupur, Manipur (Letter No. 8/86/NGO/2019-DCB(DEV), dated 16 August 2019).",
  mapEmbed:
    "https://www.google.com/maps?q=Thanga,+Bishnupur+District,+Manipur,+India&output=embed",
};

export const MISSION =
  "Since 2005, Equipping New Life has served the ethnic communities of Manipur, North East India — running a de-addiction centre, a Balwadi centre for mothers and children, an orphan home, and a counselling centre for families affected by HIV+/AIDS. We believe every person, regardless of circumstance, deserves dignity, integrity, self-reliance, health, and the hope of a new life.";

export const IMAGES = {
  hero: "https://customer-assets-agu9un31.emergentagent.net/job_new-life-ngo/artifacts/629bhpnn_IMG-20260730-WA0087.webp",
  women: "https://images.unsplash.com/photo-1616674202799-054e7c831378?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjB3b21lbiUyMGVtcG93ZXJtZW50JTIwdm9jYXRpb25hbCUyMHRyYWluaW5nfGVufDB8fHx8MTc4NDIwODA5N3ww&ixlib=rb-4.1.0&q=85",
  health: "https://customer-assets-agu9un31.emergentagent.net/job_new-life-ngo/artifacts/gvsog1io_IMG-20260730-WA0027.jpg",
  sports: "https://customer-assets-agu9un31.emergentagent.net/job_new-life-ngo/artifacts/hvs09e6s_IMG-20260730-WA0009.jpg",
  environment: "https://customer-assets-agu9un31.emergentagent.net/job_new-life-ngo/artifacts/gvsog1io_IMG-20260730-WA0027.jpg",
  children: "https://customer-assets-agu9un31.emergentagent.net/job_new-life-ngo/artifacts/629bhpnn_IMG-20260730-WA0087.webp",
  seminar: "https://customer-assets-agu9un31.emergentagent.net/job_new-life-ngo/artifacts/jhzrejmu_IMG-20260730-WA0072.jpg",
  counselling: "https://customer-assets-agu9un31.emergentagent.net/job_new-life-ngo/artifacts/wvhdofxl_IMG-20260730-WA0082.jpg",
  scholarship: "https://customer-assets-agu9un31.emergentagent.net/job_new-life-ngo/artifacts/gkhubso0_IMG-20260730-WA0012.jpg",
  relief: "https://customer-assets-agu9un31.emergentagent.net/job_new-life-ngo/artifacts/f6hp5c33_IMG-20260730-WA0066.jpg",
  poultry: "https://customer-assets-agu9un31.emergentagent.net/job_new-life-ngo/artifacts/23ah2klu_IMG-20260730-WA0120.webp",
  skills: "https://customer-assets-agu9un31.emergentagent.net/job_new-life-ngo/artifacts/ps03iqad_IMG-20260730-WA0069.jpg",
};

export const QUOTES = [
  {
    text: "We do not offer charity — we offer a hand to stand up. Every family we walk beside carries the strength to rebuild their own life.",
    author: "Konjengbam Raja Singh",
    role: "President",
  },
  {
    text: "A child fed, a mother taught, an addiction healed — these quiet acts are how a community learns to hope again.",
    author: "Moirangthem Dilip Singh",
    role: "Secretary",
  },
  {
    text: "For twenty years our doors in Thanga have stayed open to the forgotten. Dignity is not a privilege; it is a right.",
    author: "Konjengbam Raja Singh",
    role: "President",
  },
];

export const IMPACT = [
  { value: 200, suffix: "+", label: "Families supported" },
  { value: 1000, suffix: "+", label: "Children helped with education & study materials" },
  { value: 500, suffix: "+", label: "People counselled" },
  { value: 20, suffix: "+", label: "Years of service since 2005" },
];

export const PROGRAMS = [
  {
    slug: "de-addiction",
    icon: "HeartHandshake",
    title: "De-Addiction Centre",
    short: "Rehabilitation, counselling and after-care for individuals overcoming substance addiction.",
    serves: "Individuals and families affected by substance dependence.",
    image: IMAGES.seminar,
    body: "Our de-addiction centre offers structured rehabilitation, medical guidance and long-term after-care so that recovery becomes a lasting new beginning rather than a temporary pause.",
  },
  {
    slug: "balwadi",
    icon: "Baby",
    title: "Balwadi / Creche Centre",
    short: "Pre-school learning and nutrition support for young children and their mothers.",
    serves: "Young children and nursing mothers in rural Bishnupur.",
    image: IMAGES.children,
    body: "The Balwadi centre nurtures early childhood through play-based learning, warm meals and nutrition guidance for mothers — building strong foundations from the very first years.",
  },
  {
    slug: "hiv-aids-counselling",
    icon: "Ribbon",
    title: "HIV/AIDS Family Counselling",
    short: "Psychosocial support and confidential counselling for HIV/AIDS-affected families.",
    serves: "Individuals and families living with or affected by HIV/AIDS.",
    image: IMAGES.counselling,
    body: "We stand with families facing HIV/AIDS through compassionate, confidential counselling, community awareness and linkage to care — replacing stigma with support.",
  },
  {
    slug: "orphan-old-age-home",
    icon: "Home",
    title: "Orphan Home & Old-Age Home",
    short: "Residential care, education and companionship for orphaned children and the elderly.",
    serves: "Orphaned children and elderly persons without family support.",
    image: IMAGES.scholarship,
    body: "A safe home, nourishing meals, schooling for children and dignified companionship for elders — a family for those who have none.",
  },
  {
    slug: "moral-counselling",
    icon: "MessagesSquare",
    title: "Moral & General Counselling",
    short: "Guidance, mentorship and moral support for individuals and the wider community.",
    serves: "Youth, families and community members seeking guidance.",
    image: IMAGES.seminar,
    body: "Through mentorship and moral counselling we help people navigate life's difficult crossroads with clarity, resilience and renewed purpose.",
  },
  {
    slug: "skills-livelihood",
    icon: "Sprout",
    title: "Skills & Livelihood Training",
    short: "Dairy, horticulture, poultry, sericulture, fruit processing and computer/IT training.",
    serves: "Women, youth and families seeking economic independence.",
    image: IMAGES.skills,
    body: "From dairy, horticulture, agriculture, sericulture, poultry, duckery, piggery, pisciculture and bee-keeping to fruit processing and computer/IT skills — we equip people, especially women, to earn with dignity.",
  },
  {
    slug: "women-children-upliftment",
    icon: "Users",
    title: "Women & Children Upliftment",
    short: "Financial literacy, self-help and moral support initiatives for women and children.",
    serves: "Women's groups and children across Bishnupur District.",
    image: IMAGES.poultry,
    body: "We build the confidence and capability of women and children through financial literacy, self-help groups and sustained moral support.",
  },
  {
    slug: "sports-youth",
    icon: "Trophy",
    title: "Sports & Youth Development",
    short: "Games, sports competitions and camps that channel youth energy positively.",
    serves: "Children and young people of the community.",
    image: IMAGES.sports,
    body: "Sports meets, camps and friendly competitions keep youth engaged, healthy and away from harmful influences — building teamwork and leadership.",
  },
  {
    slug: "health-sanitation",
    icon: "Droplets",
    title: "Public Health & Sanitation",
    short: "Safe drinking water, sanitation drives and public toilet facilities.",
    serves: "Villages and public spaces in Bishnupur District.",
    image: IMAGES.health,
    body: "We improve access to clean drinking water and sanitation, and support public toilet facilities to protect community health.",
  },
  {
    slug: "environmental-awareness",
    icon: "Leaf",
    title: "Environmental Awareness",
    short: "Monitoring and reducing water, air and noise pollution in the region.",
    serves: "The wider Bishnupur community and Loktak ecosystem.",
    image: IMAGES.environment,
    body: "Around the fragile Loktak wetlands, we run awareness drives and monitoring to reduce water, air and noise pollution for a healthier tomorrow.",
  },
  {
    slug: "seminars-workshops",
    icon: "GraduationCap",
    title: "Seminars & Workshops",
    short: "Periodic lectures and vocational training for community upliftment.",
    serves: "Community members of all ages.",
    image: IMAGES.seminar,
    body: "Regular seminars, lectures and vocational workshops spread knowledge and practical skills across the community.",
  },
];

export const FEATURED = [
  PROGRAMS.find((p) => p.slug === "de-addiction"),
  PROGRAMS.find((p) => p.slug === "balwadi"),
  PROGRAMS.find((p) => p.slug === "hiv-aids-counselling"),
  PROGRAMS.find((p) => p.slug === "orphan-old-age-home"),
  PROGRAMS.find((p) => p.slug === "skills-livelihood"),
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Dignity before charity",
    text: "We meet every person as an equal. Our work restores self-respect, not dependence.",
  },
  {
    n: "02",
    title: "Rooted in the community",
    text: "Run by local social workers of Thanga and Moirang, our decisions come from within the community we serve.",
  },
  {
    n: "03",
    title: "Whole-person care",
    text: "Health, education, livelihood and emotional well-being — we support the entire life of a family.",
  },
  {
    n: "04",
    title: "Hope that lasts",
    text: "From de-addiction to skills training, we invest in change that outlives our presence.",
  },
];

export const TEAM = [
  { name: "Konjengbam Raja Singh", role: "President", occupation: "Social Worker", location: "Patlou Leikai, Moirang, Bishnupur", photo: "https://customer-assets-agu9un31.emergentagent.net/job_new-life-ngo/artifacts/bf5co45y_IMG-20260730-WA0007.jpg" },
  { name: "Laishram Raju Singh", role: "Vice President", occupation: "Social Worker", location: "Ithing Awang Leikai, Thanga, Bishnupur", photo: "https://customer-assets-agu9un31.emergentagent.net/job_new-life-ngo/artifacts/01dok9af_IMG-20260730-WA0003.jpg" },
  { name: "Moirangthem Dilip Singh", role: "Secretary", occupation: "Social Activities", location: "Ithing Awang Leikai, Thanga, Bishnupur", photo: "https://customer-assets-agu9un31.emergentagent.net/job_new-life-ngo/artifacts/9966zym6_IMG-20260730-WA0005.jpg" },
  { name: "Moirangthem Sharat Singh", role: "Joint Secretary", occupation: "Social Worker", location: "Ithing Awang Leikai, Thanga, Bishnupur", photo: "https://customer-assets-agu9un31.emergentagent.net/job_new-life-ngo/artifacts/ijg7jsh9_IMG-20260730-WA0004.jpg" },
  { name: "Moirangthem Rina Devi", role: "Treasurer", occupation: "Social Worker", location: "Ithing Maning Leikai, Thanga, Bishnupur", photo: "https://customer-assets-agu9un31.emergentagent.net/job_new-life-ngo/artifacts/8yu5149p_IMG-20260730-WA0006.jpg" },
];

export const NEWS = [
  {
    date: "2025",
    tag: "Relief",
    title: "Emergency relief for conflict-affected families",
    excerpt: "Distribution of essentials and counselling support for families displaced by recent unrest in Manipur.",
    image: IMAGES.relief,
  },
  {
    date: "2024",
    tag: "Livelihood",
    title: "Women's skills training batch completes fruit-processing course",
    excerpt: "A new cohort of women from Thanga graduated our fruit-processing and financial-literacy programme.",
    image: IMAGES.poultry,
  },
  {
    date: "2024",
    tag: "Youth",
    title: "Annual sports meet brings the community together",
    excerpt: "Youth from across Bishnupur District joined our games and camps focused on health and teamwork.",
    image: IMAGES.sports,
  },
];

export const DONATION = {
  upi: "equippingnewlife@upi", // <-- REPLACE WITH REAL UPI ID -->
  bank: {
    accountName: "Equipping New Life",
    accountNumber: "0000 0000 0000", // <-- REPLACE WITH REAL ACCOUNT NUMBER -->
    ifsc: "XXXX0000000", // <-- REPLACE WITH REAL IFSC -->
    bankName: "State Bank of India, Bishnupur Branch", // <-- REPLACE WITH REAL BANK -->
  },
  tiers: [
    { amount: "₹500", impact: "Study materials for a child for a month" },
    { amount: "₹1,500", impact: "A week of nutrition at the Balwadi centre" },
    { amount: "₹5,000", impact: "Counselling support for an HIV/AIDS-affected family" },
    { amount: "₹10,000", impact: "Sponsor a de-addiction rehabilitation cycle" },
  ],
};
